import { Box, Button, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import type { PortfolioArea } from "web_myplann/Portfolio/Types/portfolioCategory";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	icon: LucideIcon;
	label: string;
	area: PortfolioArea;
	onClick: () => void;
};

export const PortfolioAddItemCategoryTile: FC<Props> = ({
	icon: Icon,
	label,
	area,
	onClick,
}) => {
	const theme = useTheme();
	const { tint, ink } = theme.palette.portfolioArea[area];

	return (
		<Button
			variant="tile"
			onClick={onClick}
			startIcon={
				<IconBox bg={tint} size={32}>
					<Icon size={theme.iconSize.sm} color={ink} />
				</IconBox>
			}
		>
			<Box
				component="span"
				sx={{
					display: "-webkit-box",
					WebkitLineClamp: 2,
					WebkitBoxOrient: "vertical",
					overflow: "hidden",
					textOverflow: "ellipsis",
					minWidth: 0,
				}}
			>
				{label}
			</Box>
		</Button>
	);
};
